"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnersApiClient = createPartnersApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnersApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function getAllPartners(activated) {
        try {
            const queryParams = activated !== undefined ? { activated } : {};
            const response = await client.get('/v1/cooperatives', { params: queryParams });
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function getPartnerById(cooperativeId) {
        try {
            const response = await client.get(`/v1/cooperatives/${cooperativeId}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getAllPartners,
        getPartnerById
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lcnMuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BhcnRuZXJzL3BhcnRuZXJzLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU1BLDBEQW1DQztBQXhDRCxnREFBNEM7QUFDNUMsb0NBQXNDO0FBQ3RDLHlEQUE4RTtBQUc5RSxTQUFnQix1QkFBdUIsQ0FBQyxPQUFlLEVBQUUsT0FBMkI7SUFDbEYsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sSUFBSSx5QkFBVyxDQUFBO0lBRTVDLE1BQU0sTUFBTSxHQUFHLElBQUEsZ0NBQWlCLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBRWxELEtBQUssVUFBVSxjQUFjLENBQUMsU0FBbUI7UUFDL0MsSUFBSSxDQUFDO1lBQ0gsTUFBTSxXQUFXLEdBQUcsU0FBUyxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRSxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFBO1lBQ2hFLE1BQU0sUUFBUSxHQUFHLE1BQU0sTUFBTSxDQUFDLEdBQUcsQ0FDL0Isa0JBQWtCLEVBQ2xCLEVBQUUsTUFBTSxFQUFFLFdBQVcsRUFBRSxDQUN4QixDQUFBO1lBQ0QsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFBO1FBQ3RCLENBQUM7UUFBQyxPQUFPLEdBQUcsRUFBRSxDQUFDO1lBQ2IsSUFBSSxHQUFHLFlBQVksS0FBSztnQkFBRSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUE7WUFDdkQsSUFBQSxtQkFBVyxFQUFDLEdBQUcsQ0FBQyxDQUFBO1FBQ2xCLENBQUM7SUFDSCxDQUFDO0lBRUQsS0FBSyxVQUFVLGNBQWMsQ0FBQyxhQUFxQjtRQUNqRCxJQUFJLENBQUM7WUFDSCxNQUFNLFFBQVEsR0FBRyxNQUFNLE1BQU0sQ0FBQyxHQUFHLENBQy9CLG9CQUFvQixhQUFhLEVBQUUsQ0FDcEMsQ0FBQTtZQUNELE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQTtRQUN0QixDQUFDO1FBQUMsT0FBTyxHQUFHLEVBQUUsQ0FBQztZQUNiLElBQUksR0FBRyxZQUFZLEtBQUs7Z0JBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFBO1lBQ3ZELElBQUEsbUJBQVcsRUFBQyxHQUFHLENBQUMsQ0FBQTtRQUNsQixDQUFDO0lBQ0gsQ0FBQztJQUVELE9BQU87UUFDTCxjQUFjO1FBQ2QsY0FBYztLQUNmLENBQUE7QUFDSCxDQUFDIn0=